import {Card, CardContent} from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface MetricsData {
  sent: number;
  opened: number;
  clicked: number;
  replied: number;
  openRate: number;
  clickRate: number;
  replyRate: number;
}

interface ReportsMetricsCardsProps {
  metrics: MetricsData;
  isLoading?: boolean;
}

export function ReportsMetricsCards({ metrics, isLoading }: ReportsMetricsCardsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {[...Array(3)].map((_, i) => (
          <Card key={i} className="bg-card shadow-none border">
            <div className="p-4">
              <Skeleton className="h-4 w-20 mb-2" />
              <Skeleton className="h-8 w-16 mb-2" />
              <Skeleton className="h-3 w-12" />
            </div>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <MetricCard title="Sent" value={metrics.sent.toLocaleString()} />
      <MetricCard
        title="Clicked"
        value={metrics.clicked.toLocaleString()}
        percentage={metrics.clickRate}
      />
      <MetricCard
        title="Replied"
        value={metrics.replied.toLocaleString()}
        percentage={metrics.replyRate}
      />
    </div>
  );
}

interface MetricCardProps {
  title: string;
  value: string;
  percentage?: number;
}

function MetricCard({ title, value, percentage }: MetricCardProps) {
  return (
    <Card className="bg-card shadow-none border">
        <CardContent>
            <div className="p-0">
                <div className="text-sm text-muted-foreground mb-2">
                    {title}
                </div>
                <div className="text-2xl text-foreground">{value}</div>
                {percentage !== undefined && (
                    <div className="text-xs text-muted-foreground mt-2">
                        {percentage.toFixed(1)}%
                    </div>
                )}
            </div>
        </CardContent>
    </Card>
  );
}
